class CommonOutRange {

  constructor(table) {
    this.table = table;
  }

}

export {
  CommonOutRange,
};
